import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/DbosUserGroupMeetingPage.head';
import { DbosUserGroupMeetingPage } from '@pages/DbosUserGroupMeetingPage';

export const Route = createFileRoute('/dbos-user-group-meeting')({
  component: DbosUserGroupMeetingPage,
  head: () => head,
});
